import { Outlet } from 'react-router-dom';

import { useNarrowNav } from '@/contexts/narrowNavContext';

import { MyWorkspaceHeader } from './components';

const MyWorkspace = () => {
  // The menu navigation's top bar already names the page and carries the way around.
  const { navStyle } = useNarrowNav();

  return (
    <main>
      {navStyle === 'select' && <MyWorkspaceHeader />}

      <Outlet />
    </main>
  );
};

export default MyWorkspace;
